import React, { useState, useEffect, useRef } from 'react';
import Handlebars from 'handlebars';
import { useFirestore } from '../contexts/FirestoreContext';
import './billout.css';
import { Printer } from "react-bootstrap-icons";
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

// --- helpers ---
const N = (v) => {
  if (v == null) return 0;
  if (typeof v === 'number') return v;
  const n = parseFloat(String(v).replace(/[^0-9.-]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

// Use N() so it sums currency-like strings too
const sumField = (arr = [], field) =>
  arr.reduce((total, item) => total + N(item?.[field]), 0);

const formatCurrency = (value) => {
  if (value == null || value === '' || Number.isNaN(value)) return '';
  const numberValue = typeof value === 'number'
    ? value
    : parseFloat(String(value).replace(/,/g, ''));
  if (!Number.isFinite(numberValue)) return '';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(numberValue);
};

// --- template ---
const htmlTemplate = `<table border="0" width="568pt" cellspacing="0" cellpadding="0"><colgroup><col width="22" /><col width="108" /><col width="83" /><col width="58" /><col width="92" /><col width="87" /><col width="39" /><col width="75" /><col width="116" /><col width="75" /><col width="22" /></colgroup>
<tbody>
<tr>
<td colspan="7"><strong>Hardy Fleet Group</strong></td>
<td colspan="3"><strong>{{approvedText}}</strong></td>
</tr>
<tr>
<td colspan="7"><strong>Billout sheet</strong></td>
<td colspan="3">{{approverInitials}} - {{vehicle.approvedByName}}</td>
</tr>
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">Sales Order</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px; margin-right: 16px;" colspan="2">{{vehicle.strSalesOrdNbr}}</td>
<td style="text-align: right; padding: 2px;" colspan="1">Stock #</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{stockNum}}</td>
<td style="text-align: right; padding: 2px;" colspan="2">Sale Date</td>
<td style="border: 1.5px solid #444; padding: 2px;" colspan="1">{{saleDateText}}</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;"colspan="2">PO #</td>
<td style="border: 1.5px solid #444; padding: 2px;" colspan="2">{{salesOrder.strPONbr}}</td>
<td style="text-align: right; padding: 2px;"colspan="1">PO Line</td>
<td style="border: 1.5px solid #444; padding: 2px;" colspan="2">{{vehicle.strPONbr}}</td>
</tr>
<tr>
<td colspan="7">&nbsp;</td>
<td style="text-align: right; padding: 2px;"colspan="2">{{finFanText}}</td>
<td style="border: 1.5px solid #444; padding: 2px;" colspan="1">{{finFan}}</td>
</tr>
<tr>
<td colspan="10">Customer</td>
</tr>
<tr>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="4">{{customer.strCustName}}</td>
<td colspan="1">&nbsp;</td>
<td colspan="2">{{vehicle.strFactory}} CDK Number</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="3">{{cdkNbr}}</td>
</tr>
<tr>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="4">{{customer.strAddressLine1}}</td>
<td colspan="1">&nbsp;</td>
<td colspan="2">Reporting Type</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444;" colspan="3">{{reportingType}}</td>
</tr>
<tr>
<td style="border-top: 0.5px solid #444; border-bottom: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="4">{{customer.strCity}}, {{customer.strState}} {{customer.strZip}}</td>
<td colspan="1">&nbsp;</td>
<td colspan="2">Sales Rep ID</td>
<td style="border: 1.5px solid #444;" colspan="3">{{salesRepIdText}}</td>
</tr>
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td colspan="3">Vin</td>
<td colspan="1">Year</td>
<td colspan="2">Make</td>
<td colspan="3">Model</td>
<td colspan="1">Miles</td>
</tr>
<tr>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-bottom: 1.5px solid #444;" colspan="3">{{vehicle.strVin}}</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-bottom: 1.5px solid #444;" colspan="1">{{vehicle.strYR}}</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-bottom: 1.5px solid #444;" colspan="2">{{vehicle.strMake}}</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-bottom: 1.5px solid #444;" colspan="3">{{vehicle.strModel}}</td>
<td style="border: 1.5px solid #444;" colspan="1">10</td>
</tr>
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">MSRP</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{fcurVehMSRP}}</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">Sale Price</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{fcurVehSalePrice}}</td>
<td style="text-align: right; padding: 2px;" colspan="2">Vehicle Cost</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{fcurVehCOS}}</td>
<td style="text-align: right; padding: 2px;">Accessory</td>
<td style="border-top: 1.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="1">{{accessoriesTotal}}</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">Trade Allow</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{tradeAllowanceTotal}}</td>
<td style="text-align: right; padding: 2px;" colspan="2">Trade ACV</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{tradeAcvTotal}}</td>
<td style="text-align: right; padding: 2px;" colspan="1">Transport</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="1">{{transportTotal}}</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">Trade Payoff</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{tradePayoffTotal}}</td>
<td style="text-align: right; padding: 2px;" colspan="2">HB / VQ2</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{fcurVQ2}}</td>
<td style="text-align: right; padding: 2px;" colspan="1">Contract Fee</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="1">{{fcurDOAS}}</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">Rebate</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{rebatesTotal}}</td>
<td style="text-align: right; padding: 2px;" colspan="2">Assit / Incent</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{assistanceTotal}}</td>
<td style="text-align: right; padding: 2px;" colspan="1">ETR Fee</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; border-bottom: 1.5px solid #444; padding: 2px;" colspan="1">{{etrFee}}</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">Taxes</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; padding: 2px;" colspan="2">{{fcurTaxes}}</td>
<td style="text-align: right; padding: 2px;" colspan="2">Upfit Cost</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; border-bottom: 1.5px solid #444; padding: 2px;" colspan="2">{{upfitTotal}}</td>
</tr>
<tr>
<td style="text-align: right; padding: 2px;" colspan="2">T&amp;T Fees</td>
<td style="border-top: 0.5px solid #444; border-left: 1.5px solid #444; border-right: 1.5px solid #444; border-bottom: 1.5px solid #444; padding: 2px;" colspan="2">{{fcurTTFees}}</td>
<td style="text-align: right; padding: 2px;" colspan="2">Total Cost</td>
<td style="padding: 2px;" colspan="2"><strong>{{totalCost}}</strong></td>
<td style="text-align: right; padding: 2px;" colspan="1">Front Gross</td>
<td style="padding: 2px;" colspan="1"><strong>{{frontGross}}</strong></td>
</tr>
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td style="text-align: center; padding: 2px;" colspan="3">Warranty Type</td>
<td style="text-align: center; padding: 2px;" colspan="2">Sale Price</td>
<td style="text-align: center; padding: 2px;" colspan="2">Cost</td>
</tr>
{{{warrantyHtml}}}
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td style="padding: 2px;" colspan="2">Amount Due</td>
<td style="padding: 2px;"><strong>{{amountDue}}</strong></td>
<td style="padding: 2px;" colspan="4">&nbsp;</td>
<td style="text-align: right; padding: 2px;" colspan="2">Total Gross</td>
<td style="padding: 2px;"><strong>{{totalGross}}</strong></td>
</tr>
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td style="text-align: left; padding: 2px;" colspan="2">Assistance</td>
</tr>
<tr>
<td style="text-align: center; padding: 2px;" colspan="2">Bid #</td>
<td style="text-align: center; padding: 2px;" colspan="1">Item #</td>
<td style="text-align: center; padding: 2px;" colspan="2">Amount</td>
<td style="text-align: center; padding: 2px;" colspan="1">&nbsp;</td>
<td style="text-align: center; padding: 2px;" colspan="2">Rebate #</td>
<td style="text-align: center; padding: 2px;" colspan="2">Amount</td>
</tr>
{{{assistanceHtml}}}
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td style="text-align: center; padding: 2px;" colspan="3">Upfitter / Accessory</td>
<td style="text-align: center; padding: 2px;" colspan="2">Cost</td>
<td style="text-align: center; padding: 2px;" colspan="5">Description</td>
</tr>
{{{upfitAccessoryHtml}}}
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
<td colspan="8">Notes</td>
</tr>
<tr>
<td colspan="1">&nbsp;</td>
<td style="white-space: normal; word-wrap: break-word; vertical-align: top; padding: 4px; border: 1.5px solid #444; width: 200px; max-width: 200px;" colspan="8" rowspan="4">{{vehicle.strBillNotes}}</td>
</tr>
<tr>
<td colspan="2">&nbsp;</td>
</tr>
<tr>
<td colspan="2">&nbsp;</td>
</tr>
<tr>
<td colspan="2">&nbsp;</td>
</tr>
<tr>
<td colspan="10">&nbsp;</td>
</tr>
<tr>
  <td style="padding: 2px; text-align: left;" colspan="2">Trade Info</td>
</tr>
<tr>
  <td style="text-align: center; padding: 2px;" colspan="3">VIN</td>
  <td style="text-align: center; padding: 2px;" colspan="1">Year</td>
  <td style="text-align: center; padding: 2px;" colspan="5">Make / Model</td>
  <td style="text-align: center; padding: 2px;" colspan="1">Mileage</td>
</tr>
{{{tradeInfoHtml}}}
</tbody>
</table>`;

const template = Handlebars.compile(htmlTemplate);

const BillOutSheet = ({ vehicle = {}, salesOrder = {}, customer = {} }) => {
  const [salesRep, setSalesRep] = useState(null);
  const { queryData } = useFirestore();

  // Reference to the rendered billout HTML
  const containerRef = useRef(null);

  const getSalesRep = async (so) => {
    const salesId = await queryData('salesIds', 'strSalesIdNbr', '==', so.strSalesId);
    if (!salesId || salesId.length === 0) return null;
    return salesId[0];
  };

  useEffect(() => {
    getSalesRep(salesOrder).then(setSalesRep).catch(() => setSalesRep(null));
  }, [salesOrder]);

  if (salesRep === null) {
    return <div>Loading…</div>;
  }

  // --- simple display fields ---
  const approverInitials = (vehicle.approvedByName || '')
    .split(' ')
    .filter(Boolean)
    .map(n => n[0])
    .join('')
    .toUpperCase();

  const approvedText = vehicle.approved ? 'Approved' : 'Pending';
  const stockNum = vehicle.strVin ? vehicle.strVin.slice(-8) : '';

  const jsDate = vehicle.dtSaleDate?.toDate?.();
  const saleDateText = jsDate
    ? jsDate.toLocaleDateString('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    : '';

  const finFan = (vehicle?.strFactory?.toUpperCase() === 'FORD' || vehicle?.strMake?.toUpperCase() === 'FORD')
    ? customer.strCustFordFIN
    : customer.strCustGMFIN;

  const cdkNbr = (vehicle?.strFactory?.toUpperCase() === 'FORD' || vehicle?.strMake?.toUpperCase() === 'FORD')
    ? customer.strCDKCustNbrFord
    : customer.strCDKCustNbrGM;

  console.log('Vehicle:', vehicle);
  console.log('CDK Number:', cdkNbr);
  console.log('Customer:', customer);

  const reportingType = (vehicle?.strFactory?.toUpperCase() === 'FORD' || vehicle?.strMake?.toUpperCase() === 'FORD')
    ? salesOrder.strFordReportingType
    : salesOrder.strGMReportingType;

  const salesRepIdText = (vehicle?.strFactory?.toUpperCase() === 'FORD' || vehicle?.strMake?.toUpperCase() === 'FORD')
    ? `${salesRep.strSalesIdName} - ${salesRep.strFordSalesRepId}`
    : `${salesRep.strSalesIdName} - ${salesRep.strGmSalesRepId}`;

  const finFanText = 'FIN/FAN';

  // --- numeric primitives (coerced) ---
  const nVehMSRP = N(vehicle.curVehMSRP);
  const nVehSalePrice = N(vehicle.curVehSalePrice);
  const nVehCOS = N(vehicle.curVehCOS);
  const nTaxes = N(vehicle.curTaxes);
  const nTTFees = N(vehicle.curTTFees);
  const nVQ2 = N(vehicle.curVQ2);       // HB/VQ2 (subtract from cost)
  const nDOAS = N(vehicle.curDoas);      // Contract fee
  const nFinResrv = N(vehicle.curFinResrv);  // Finance reserve
  const nEtrFee = vehicle.bETRFee ? 10 : 0;

  const nAccessoriesTotal = sumField(vehicle.arrAccessories, 'amount');
  const nTradeAllowanceTotal = sumField(vehicle.arrTradeIns, 'allowance');
  const nTradeAcvTotal = sumField(vehicle.arrTradeIns, 'acv');
  const nTradePayoffTotal = sumField(vehicle.arrTradeIns, 'payoff');
  const nTransportTotal = sumField(vehicle.arrTransport, 'amount');
  const nRebatesTotal = sumField(vehicle.arrRebates, 'amount');
  const nAssistanceTotal = sumField(vehicle.arrAssistance, 'amount');
  const nUpfitTotal = sumField(vehicle.arrUpfitterItems, 'amount');

  // Warranty totals
  const nWarrantySaleTotal = (vehicle.arrWarranty || []).reduce((t, w) => t + N(w.salePrice), 0);
  const nWarrantyCostTotal = (vehicle.arrWarranty || []).reduce((t, w) => t + N(w.cost), 0);

  // --- BUSINESS LOGIC (as specified) ---
  // Amount Due = Sale Price - Trade Allow + Trade Payoff - Rebate + Taxes + T&T Fees
  const nAmountDue =
    nVehSalePrice
    - nTradeAllowanceTotal
    + nTradePayoffTotal
    - nRebatesTotal
    + nTaxes
    + nTTFees;

  // Total Cost = Vehicle Cost
  //   + (Trade Allow - Trade ACV)
  //   - HB/VQ2
  //   - Assistance/Incentive (subtract total; negatives become additions)
  //   + Upfit + Accessory + Transport
  //   + DOAS + ETR Fee
  const nTotalCost =
    nVehCOS
    + (nTradeAllowanceTotal - nTradeAcvTotal)
    - nVQ2
    - nAssistanceTotal
    + nUpfitTotal
    + nAccessoriesTotal
    + nTransportTotal
    + nDOAS
    + nEtrFee;

  // Front Gross = Sale Price - Total Cost
  const nFrontGross = nVehSalePrice - nTotalCost;

  // Back Gross = (Total Warranty Sales - Total Warranty Cost) + Finance Reserve
  const nBackGross = (nWarrantySaleTotal - nWarrantyCostTotal) + nFinResrv;

  // Total Gross = Front + Back
  const nTotalGross = nFrontGross + nBackGross;

  // --- formatted strings for template ---
  const fcurVehMSRP = formatCurrency(nVehMSRP);
  const fcurVehSalePrice = formatCurrency(nVehSalePrice);
  const fcurTaxes = formatCurrency(nTaxes);
  const fcurTTFees = formatCurrency(nTTFees);
  const fcurVehCOS = formatCurrency(nVehCOS);
  const fcurVQ2 = formatCurrency(nVQ2);
  const fcurDOAS = formatCurrency(nDOAS);

  const accessoriesTotal = formatCurrency(nAccessoriesTotal);
  const tradeAllowanceTotal = formatCurrency(nTradeAllowanceTotal);
  const tradeAcvTotal = formatCurrency(nTradeAcvTotal);
  const tradePayoffTotal = formatCurrency(nTradePayoffTotal);
  const transportTotal = formatCurrency(nTransportTotal);
  const rebatesTotal = formatCurrency(nRebatesTotal);
  const assistanceTotal = formatCurrency(nAssistanceTotal);
  const upfitTotal = formatCurrency(nUpfitTotal);

  const frontGross = formatCurrency(nFrontGross);
  const backGross = formatCurrency(nBackGross);
  const totalCost = formatCurrency(nTotalCost);
  const amountDue = formatCurrency(nAmountDue);
  const totalGross = formatCurrency(nTotalGross);
  const etrFee = formatCurrency(nEtrFee);

  const handlePrint = () => {
    const el = containerRef.current;
    if (!el) return;

    const sheetHtml =
      el.innerHTML?.trim() ? el.innerHTML : el.outerHTML;

    const styles = Array.from(
      document.querySelectorAll('link[rel="stylesheet"], style')
    )
      .map(n => n.outerHTML)
      .join('\n');

    const printable = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Bill Out Sheet</title>
  ${styles}
  <style>
    @page { size: letter portrait; margin: 0.5in; }
    html, body { padding: 0; margin: 0; }
    table { border-collapse: collapse; }
    td { font-family: Arial, Helvetica, sans-serif; font-size: 11px; }
    * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .billout-print-controls { display: none !important; }
  </style>
</head>
<body>
  <div class="billout-sheet-container">
    ${sheetHtml}
  </div>
</body>
</html>`.trim();

    // Create hidden iframe
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.style.left = '-9999px';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document || iframe.contentDocument;
    doc.open();
    doc.write(printable);
    doc.close();

    let printed = false; // ensure doPrint runs once
    let cleaned = false; // ensure cleanup runs once
    let timerId;

    const cleanup = () => {
      if (cleaned) return;
      cleaned = true;

      // remove listeners
      iframe.onload = null;
      const w = iframe.contentWindow;
      if (w && w.removeEventListener) {
        w.removeEventListener('afterprint', cleanup);
        w.removeEventListener('pagehide', cleanup);
      }
      window.removeEventListener('focus', onFocusOnce);

      // remove iframe only if still attached
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
      if (timerId) clearTimeout(timerId);
    };

    const onFocusOnce = () => cleanup();

    const doPrint = () => {
      if (printed) return;
      printed = true;

      const w = iframe.contentWindow;
      if (!w) return cleanup();

      // when the print dialog closes (OK or Cancel), run cleanup
      if (w.addEventListener) {
        w.addEventListener('afterprint', cleanup, { once: true });
        w.addEventListener('pagehide', cleanup, { once: true }); // Safari fallback
      }
      window.addEventListener('focus', onFocusOnce, { once: true }); // general fallback

      try {
        w.focus();
        w.print();
      } catch (e) {
        // if printing fails, just clean up
        cleanup();
        return;
      }

      // final failsafe cleanup in case events don't fire
      timerId = setTimeout(cleanup, 2000);
    };

    // some browsers won’t fire onload after document.write; keep a fallback
    const fallbackDelayMs = 500;
    timerId = setTimeout(doPrint, fallbackDelayMs);
    iframe.onload = () => {
      if (timerId) clearTimeout(timerId);
      doPrint();
    };
  };


  // Trade Info rows (VIN, Year, Make/Model, Miles)
  // Uses the same top/middle/bottom border logic as the other tables.
  function buildTradeInfoRows(arr = []) {
    const source = (arr && arr.length ? arr : new Array(2).fill({}));

    return source.map((t, i) => {
      const isFirst = i === 0;
      const isLast = i === source.length - 1;
      const bt = isFirst ? '1.5px solid #444' : '0.5px solid #444';
      const bb = isLast ? '1.5px solid #444' : '0.5px solid #444';

      const vin = t.vin ?? '&nbsp;';
      const year = t.year ?? '&nbsp;';
      const makeModel = t.makeModel ?? '&nbsp;';

      // Format miles as a number with thousands separators if possible
      let milesDisp = '&nbsp;';
      if (t.miles != null && t.miles !== '') {
        const n = Number(String(t.miles).replace(/[^0-9.-]/g, ''));
        milesDisp = Number.isFinite(n) ? n.toLocaleString('en-US') : String(t.miles);
      }

      return `
      <tr>
        <!-- VIN (3 cols, left border box) -->
        <td colspan="3" style="
            border-top:${bt}; border-bottom:${bb};
            border-left:1.5px solid #444;
            padding:2px; text-align:left;">
          ${vin}
        </td>

        <!-- Year (1 col) -->
        <td colspan="1" style="
            border-top:${bt}; border-bottom:${bb};
            border-left:0.5px solid #444;
            padding:2px; text-align:center;">
          ${year}
        </td>

        <!-- Make / Model (5 cols) -->
        <td colspan="5" style="
            border-top:${bt}; border-bottom:${bb};
            border-left:0.5px solid #444;
            padding:2px; text-align:left;">
          ${makeModel}
        </td>

        <!-- Mileage (1 col, right border box) -->
        <td colspan="1" style="
            border-top:${bt}; border-bottom:${bb};
            border-left:0.5px solid #444; border-right:1.5px solid #444;
            padding:2px; text-align:center;">
          ${milesDisp}
        </td>
      </tr>
    `;
    }).join('');
  }

  // --- row builders (display) ---
  function buildWarrantyRows(arrWarranty = [], curFinResrv = '', backGrossDisp = '') {
    const source = arrWarranty.length
      ? arrWarranty
      : new Array(2).fill({ type: '&nbsp;', salePrice: '&nbsp;', cost: '&nbsp;' });

    return source.map((w, i) => {
      const isFirst = i === 0;
      const isLast = i === source.length - 1;

      const borderTop = isFirst ? '1.5px solid #444' : '0.5px solid #444';
      const borderBottom = isLast ? '1.5px solid #444' : '0.5px solid #444';

      let row = `
      <tr>
        <td colspan="3" style="
            border-top: ${borderTop};
            border-bottom: ${borderBottom};
            border-left: 1.5px solid #444;
            border-right: 0.5px solid #444;
            padding: 2px;
          ">${w.type}</td>
        <td colspan="2" style="
            border-top: ${borderTop};
            border-bottom: ${borderBottom};
            padding: 2px;
          ">${formatCurrency(w.salePrice)}</td>
        <td colspan="2" style="
            border-top: ${borderTop};
            border-bottom: ${borderBottom};
            border-left: 0.5px solid #444;
            border-right: 1.5px solid #444;
            padding: 2px;
          ">${formatCurrency(w.cost)}</td>
    `;

      if (isFirst) {
        row += `
        <td>&nbsp;</td>
        <td style="text-align:right; padding:2px;">Fin Resrv</td>
        <td style="border:1.5px solid #444; padding:2px;">${curFinResrv}</td>
      `;
      } else if (isLast) {
        row += `
        <td>&nbsp;</td>
        <td style="text-align:right; padding:2px;">Back Gross</td>
        <td style="padding:2px;"><strong>${backGrossDisp}</strong></td>
      `;
      } else {
        row += `<td colspan="3"></td>`;
      }

      row += `</tr>`;
      return row;
    }).join('');
  }

  // Upfit / Accessory rows builder (single 3-col left cell, no bold)
  function buildUpfitAccessoryRows(arrUpfit = [], arrAccessories = []) {
    const merged = [
      ...(arrUpfit || []).map(x => ({ ...x, __kind: 'Upfitter' })),
      ...(arrAccessories || []).map(x => ({ ...x, __kind: 'Accessory' })),
    ];

    const source = merged.length ? merged : new Array(2).fill({ __kind: '&nbsp;' });

    return source.map((a, i) => {
      const isFirst = i === 0;
      const isLast = i === source.length - 1;
      const bt = isFirst ? '1.5px solid #444' : '0.5px solid #444';
      const bb = isLast ? '1.5px solid #444' : '0.5px solid #444';

      const vendor = a.upfitter ?? a.vendor ?? a.name ?? a.type ?? '';
      const cost = formatCurrency(a.amount) || '&nbsp;';
      const desc = a.description ?? a.desc ?? a.details ?? '&nbsp;';
      const kind = a.__kind ?? '&nbsp;';

      return `
      <tr>
        <td colspan="3" style="
            border-top:${bt}; border-bottom:${bb};
            border-left:1.5px solid #444;
            padding:2px; text-align:left;">
          ${kind}${vendor ? ' &ndash; ' + vendor : ''}
        </td>
        <td colspan="2" style="
            border-top:${bt}; border-bottom:${bb};
            border-left:0.5px solid #444;
            padding:2px; text-align:center;">
          ${cost}
        </td>
        <td colspan="5" style="
            border-top:${bt}; border-bottom:${bb};
            border-left:0.5px solid #444; border-right:1.5px solid #444;
            padding:2px; text-align:left;">
          ${desc}
        </td>
      </tr>
    `;
    }).join('');
  }

  function buildAssistanceRows(arrAssistance = [], arrRebates = []) {
    const rowCount = Math.max(arrAssistance.length, arrRebates.length, 1);

    return Array.from({ length: rowCount })
      .map((_, i) => {
        const a = arrAssistance[i] || { bid: '&nbsp;', item: '&nbsp;', amount: '&nbsp;' };
        const r = arrRebates[i] || { number: '&nbsp;', amount: '&nbsp;' };

        const isFirst = i === 0;
        const isLast = i === rowCount - 1;
        const bt = isFirst ? '1.5px solid #444' : '0.5px solid #444';
        const bb = isLast ? '1.5px solid #444' : '0.5px solid #444';

        return `
        <tr>
          <td colspan="2" style="
              border-top:${bt}; border-bottom:${bb}; border-left:1.5px solid #444;
              border-right:0.5px solid #444; padding:2px; text-align:left;">
            ${a.bid}
          </td>
          <td colspan="1" style="
              border-top:${bt}; border-bottom:${bb}; padding:2px; text-align:center;">
            ${a.item}
          </td>
          <td colspan="2" style="
              border-top:${bt}; border-bottom:${bb};
              border-left:0.5px solid #444; border-right:1.5px solid #444;
              padding:2px; text-align:center;">
            ${formatCurrency(a.amount)}
          </td>
          <td colspan="1">&nbsp;</td>
          <td colspan="2" style="
              border-top:${bt}; border-bottom:${bb}; border-left:1.5px solid #444;
              border-right:0.5px solid #444; padding:2px; text-align:center;">
            ${r.number}
          </td>
          <td colspan="2" style="
              border-top:${bt}; border-bottom:${bb}; border-left:0.5px solid #444;
              border-right:1.5px solid #444; padding:2px; text-align:center;">
            ${formatCurrency(r.amount)}
          </td>
        </tr>
      `;
      })
      .join('');
  }

  const tradeInfoHtml = buildTradeInfoRows(vehicle.arrTradeIns);

  const warrantyHtml = buildWarrantyRows(
    vehicle.arrWarranty,
    formatCurrency(nFinResrv),
    backGross
  );

  const upfitAccessoryHtml = buildUpfitAccessoryRows(
    vehicle.arrUpfitterItems,
    vehicle.arrAccessories
  );

  const assistanceHtml = buildAssistanceRows(
    vehicle.arrAssistance,
    vehicle.arrRebates
  );

  // --- final template context ---
  const context = {
    // raw props
    vehicle,
    salesOrder,
    customer,

    // formatted primitives
    fcurVehMSRP,
    fcurVehSalePrice,
    fcurTaxes,
    fcurTTFees,
    fcurVehCOS,
    fcurVQ2,
    fcurDOAS,

    // simple flags/text
    approvedText,
    approverInitials,
    stockNum,
    saleDateText,
    finFanText,
    finFan,
    cdkNbr,
    reportingType,

    // totals (formatted)
    accessoriesTotal,
    tradeAllowanceTotal,
    tradeAcvTotal,
    tradePayoffTotal,
    transportTotal,
    rebatesTotal,
    assistanceTotal,
    upfitTotal,

    etrFee,
    taxes: fcurTaxes,
    ttFees: fcurTTFees,

    // computed totals/grosses (formatted)
    frontGross,
    backGross,
    totalCost,
    amountDue,
    totalGross,

    // arrays
    arrAccessories: vehicle.arrAccessories,
    arrTradeIns: vehicle.arrTradeIns,
    arrRebates: vehicle.arrRebates,
    arrAssistance: vehicle.arrAssistance,
    arrUpfitterItems: vehicle.arrUpfitterItems,
    arrWarranty: vehicle.arrWarranty,

    // html fragments
    warrantyHtml,
    assistanceHtml,
    upfitAccessoryHtml,
    tradeInfoHtml,

    salesRepIdText,
  };

  const html = template(context);

  return (
    <>
      {vehicle?.approved && (
        <div className="billout-print-controls" style={{ marginBottom: 12 }}>
          <button type="button" onClick={handlePrint}>Print</button>
          {/*
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-bill-print`}>Print Billout</Tooltip>}
          >
            <Button
              variant="link"
              size="lg"
              onClick={() => handlePrint()}
            >
              <Printer />
            </Button>
          </OverlayTrigger>*/}
        </div>
      )}
      <div
        ref={containerRef}
        className="billout-sheet-container"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </>
  );

};

export default BillOutSheet;
